export default (
  state = {
    appView: "salesOps",
  },
  action,
) => {
  switch (action.type) {
    case "TOGGLE_VIEW":
      return { ...state, appView: action.payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/NavBarReducer.js